document.addEventListener("DOMContentLoaded", () => {
    // Target the specific name field
    const nameField = document.querySelector(".gfield.gfield--type-name")

    if (nameField) {
        // Find the label and description within this field
        const label = nameField.querySelector(".gfield_label.gform-field-label")
        const description = nameField.querySelector(".gfield_description")

        if (label && description) {
            // Create the wrapper div
            const wrapper = document.createElement("div")
            wrapper.className = "gfield-wrapper !flex !items-center !gap-x-1"

            // Get reference to the element after which we'll insert the wrapper
            // (This is typically right at the beginning of the fieldset)
            const referenceNode = nameField.firstChild

            // Insert the wrapper at the beginning of the fieldset
            nameField.insertBefore(wrapper, referenceNode)

            // Move the label and description into the wrapper
            wrapper.appendChild(label)
            wrapper.appendChild(description)
        }
    }

    // Auto-fill functionality for Name, Email, and BirthDate fields
    function autoFillUserData() {
        // Check if user is logged in by making an AJAX request
        jQuery.ajax({
            url: "/wp-admin/admin-ajax.php",
            type: "POST",
            data: {
                action: "get_current_user_data",
            },
            success: (response) => {
                if (response.success && response.data) {
                    const userData = response.data
                    console.log(userData)
                    // Auto-fill name field (ID: 9)
                    // if (userData.first_name && userData.last_name) {
                        jQuery("#input_3_9_3").val(userData.first_name) // First name
                        jQuery("#input_3_9_6").val(userData.last_name) // Last name
                    // }

                    // Auto-fill email field (ID: 4)
                    if (userData.email) {
                        jQuery("#input_3_4").val(userData.email)
                    }

                    // Auto-fill birth date field (ID: 5)
                    if (userData.birth_date) {
                        jQuery("#input_3_5").val(userData.birth_date)
                    }
                }
            },
        })
    }

    // Call the auto-fill function when the form is loaded
    //autoFillUserData()

    // Set datepicker options
    gform.addFilter("gform_datepicker_options_pre_init", (optionsObj) => {
        // add your own field ID instead of 2
        optionsObj.minDate = 0
        return optionsObj
    })

    // Store the hospital department dropdown for later use
    const hospitalDepartmentDropdown = document.querySelector("#input_3_18")

    // Re-apply the hospital department dropdown after form render
    jQuery(document).on("gform_post_render", (event, form_id, current_page) => {
        const afterHospitalDepartmentDropdown = document.querySelector("#input_3_18")
        if (afterHospitalDepartmentDropdown && hospitalDepartmentDropdown) {
            afterHospitalDepartmentDropdown.innerHTML = hospitalDepartmentDropdown.innerHTML
        }

        // Re-apply auto-fill after form render (useful for multi-page forms)
        //autoFillUserData()
    })

    // const { __, _x, _n, sprintf } = wp.i18n;
    //
    // // Initial check
    // translateDateValidation();
    //
    // // Also check when Gravity Forms refreshes the form
    // if (typeof jQuery !== 'undefined' && typeof jQuery(document).on === 'function') {
    //     jQuery(document).on('gform_post_render', function() {
    //         translateDateValidation();
    //     });
    // }
    //
    // function translateDateValidation() {
    //     // Target the specific validation message element
    //     const dateValidationMsg = document.getElementById('validation_message_3_5');
    //     if (dateValidationMsg && dateValidationMsg.innerHTML.indexOf('Tháng, Ngày, Năm') !== -1) {
    //         // Use WordPress i18n translation
    //         dateValidationMsg.innerHTML = __('Please fill in this field. Fields required: Month, Day, Year.', 'hellu');
    //     }
    // }
    //
    // console.log(__('Hello Paul', 'hellu'));
})

document.addEventListener("DOMContentLoaded", () => {
    // Debug wp.i18n availability
    console.log("wp available:", typeof wp !== "undefined")
    console.log("wp.i18n available:", typeof wp !== "undefined" && typeof wp.i18n !== "undefined")
    console.log(
        "wp.i18n.__ available:",
        typeof wp !== "undefined" && typeof wp.i18n !== "undefined" && typeof wp.i18n.__ === "function",
    )
})


